import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home1.vue";
import Aidtools from "../views/Aidtools.vue";
import Guchebao from "../views/Guchebao.vue";
import X431mr from "../views/X431mr.vue";
import Aboutus from "../views/Aboutus.vue";
import News from "../views/News.vue";
import Techservice from "../views/Techservice.vue";
import Softwaredownload from "../views/Softwaredownload.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/home",
    name: "home",
    component: Home,
  },
  {
    path: "/aidtools",
    name: "aidtools",
    component: Aidtools,
  },
  {
    path: "/guchebao",
    name: "估车宝",
    component: Guchebao,
  },
  {
    path: "/x431mr",
    name: "x431mr",
    component: X431mr,
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: Aboutus,
  },
  {
    path: "/agent",
    name: "AGENT",
    component: () => import("../views/agent.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: News,
  },
  {
    path: "/techservice",
    name: "techservice",
    component: Techservice,
  },
  {
    path: "/softwaredownload",
    name: "softwaredownload",
    component: Softwaredownload,
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
  // scrollBehavior() {
  //   return { x: 0, y: 0 };
  // }
});
router.beforeEach((to, from, next) => {
  if (to.query.hashId == undefined) {
    window.scrollTo(0, 0);
  }
  next();
});
export default router;
